import React, { useContext, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Row, Col } from "react-bootstrap";
import { logInWithEmailAndPassword, auth } from "../../utils/firebase";
import { AppContext } from "../../context/AppContext";
import { useMutation } from "@apollo/client";
import QUERY from "../../utils/service/query";

const LoginForm = ({ hasLabel, layout }) => {
  const [updateAdminLastLoginAt] = useMutation(
    QUERY.ACCOUNT.UPDATE_ADMIN_LAST_LOGIN_AT,
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useContext(AppContext);
  // State
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: false,
  });

  // Handler
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const res = await logInWithEmailAndPassword(
        formData.email,
        formData.password,
      );

      const tokenResult = await auth.currentUser.getIdTokenResult(true);

      if (tokenResult.claims.superAdmin || tokenResult.claims.admin) {
        const token = await res._tokenResponse.idToken;
        const userRes = await JSON.stringify({
          ...res.user,
          isSuperAdmin: tokenResult.claims.superAdmin || false,
        });
        await window.localStorage.setItem("user", userRes);
        await window.localStorage.setItem("token", token);
        await window.localStorage.setItem("isUserLoggedIn", "true");
        if (formData.remember) {
          localStorage.setItem(
            "login-data",
            CryptoJS.AES.encrypt(
              JSON.stringify(formData),
              process.env.REACT_APP_PRIVATE_KEY || "iD@dmin2022",
            ).toString(),
          );
        } else {
          localStorage.removeItem("login-data");
        }
        await updateAdminLastLoginAt();
        const user = {
          user: {
            ...res.user,
            isSuperAdmin: tokenResult.claims.superAdmin || false,
          },
          isUserLoggedIn: true,
          token: res._tokenResponse.idToken,
        };
        setUser(user);
        toast.dismiss();
        toast.success("Successfully logged in");
        navigate("/");
      } else {
        toast.dismiss();
        toast.error("Not an admin");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.dismiss();
      toast.error("Invalid username/password");
    }
  };

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // useEffect(() => {
  //   const loginDataStr = localStorage.getItem("login-data");
  //   if (loginDataStr) {
  //     const bytes = CryptoJS.AES.decrypt(
  //       loginDataStr,
  //       process.env.REACT_APP_PRIVATE_KEY || "iD@dmin2022",
  //     );
  //     const loginData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //     setFormData({
  //       email: loginData?.email,
  //       password: loginData?.password,
  //       remember: loginData?.remember,
  //     });
  //   }
  // }, []);

  useEffect(() => {
    const loginDataStr = localStorage.getItem("login-data");
    if (loginDataStr) {
      const bytes = CryptoJS.AES.decrypt(
        loginDataStr,
        process.env.REACT_APP_PRIVATE_KEY || "iD@dmin2022",
      );
      const bytesStr = bytes.toString(CryptoJS.enc.Utf8);
      if (bytesStr) {
        const loginData = JSON.parse(bytesStr);
        setFormData({
          email: loginData?.email,
          password: loginData?.password,
          remember: loginData?.remember,
        });
      } else {
        localStorage.removeItem("login-data");
      }
    }
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Email address" : ""}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
          size="md"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Password" : ""}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
          size="md"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remember: e.target.checked,
                })
              }
            />
            <Form.Check.Label className="ms-2 mb-0">
              Remember Me
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link className="fs--1 mb-0" to={`/auth/forgot-password`}>
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password || loading}>
          {loading ? "Logging In" : "Log in"}
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
};

LoginForm.defaultProps = {
  layout: "simple",
  hasLabel: false,
};

export default LoginForm;
